import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { useLanguage } from '@/contexts/LanguageContext';

/**
 * Settings card that allows service administrators to toggle feature flags
 * for the current organization. Currently empty — kept as a shell for future flags.
 */
export function FeatureFlagsSettingsCard() {
  const { t } = useLanguage();

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t.settings.featureFlags.title}</CardTitle>
        <CardDescription>{t.settings.featureFlags.description}</CardDescription>
      </CardHeader>
      <CardContent>
        <p className="text-sm text-muted-foreground">
          {t.settings.featureFlags.description}
        </p>
      </CardContent>
    </Card>
  );
}
